import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CancelForbearanceWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('cancelForbearanceWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
});
export type CancelForbearanceWorkoutPlanEvent = z.infer<typeof CancelForbearanceWorkoutPlanEvent>;
